import React, { Component, useEffect, useState } from "react";
import { Form, Button, Col, Container, Row, Tab, Nav, Table } from "react-bootstrap";
import {
  DISCOUNTTYPE,
  REFREE,
  STAFFDISC,
  FIXEDDISC,
  PAYMODES,
  PAYMODE_TYPE,
  CASH,
  CHEQUE,
  ONLINE,
  STAFF,
  FULL_PAYMENT,
  TWIN,
  REFERENCE,
  PAYMENT_DUE,
  ADMISSION,
  ADMISSION_FORWARD,
  PAYMENT_FOR_DRESS,
  SEND_PAYMENT_LINK_FATHER,
  SEND_PAYMENT_LINK_MOTHER,
} from "../../constants";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { payNow } from "../../../redux/actions/paymentAction";
import { useForm } from "react-hook-form";
import PageLoader from "../../../common/Loader";
import { ERROR, ToastMessage } from "../../../common/ToastMessage";
import SweetAlert from "react-bootstrap-sweetalert";

const PaymentDetails = (props) => {
  const { payFrom, payData } = props;
  console.log(payData)
  const dispatch = useDispatch();
  const { studentProfileDetails } = useSelector((state) => state.student);
  const { loader } = useSelector((state) => state.payment);
  const [refType, setRefType] = useState("");
  const [refreeName, setRefreeName] = useState(REFREE[0]);
  const [refDiscount, setRefDiscount] = useState({});
  const [totalFee, setTotalFee] = useState(payData.totalFee);
  const [courseFee, setCourseFee] = useState(payData.courseFee || 0);
  const [cashValue, setCashValue] = useState(0);
  const [paymentConfirmShow,setPaymentConfirmShow] = useState(false);
  const [paymentReqParams,setPaymentReqParams] = useState({});
  // const [isOtherAmount, setIsOtherAmount] = useState("ToBePaid");
  // const [payMode, setPayMode] = useState("");
  const [notesCount, setNotesCount] = useState({
    2000: 0,
    500: 0,
    200: 0,
    100: 0,
  });
  let validationSchema = Yup.object().shape({
    courseFee: Yup.string().required("Course Fee is required "),
    isOtherAmount: Yup.string().required("Field is required "),
    discountType: Yup.string().nullable(),
    payMode: Yup.string().required("PayMode is required "),
    refName: Yup.string()
      .ensure()
      .when("discountType", {
        is: REFERENCE,
        then: Yup.string().required("RefName is required "),
      }),
    discount: Yup.string()
      .ensure()
      .when("discountType", {
        is: REFERENCE,
        then: Yup.string().required("Discount is required "),
      }),
    twoThousand: Yup.string()
      .ensure()
      .when("payMode", {
        is: CASH,
        then: Yup.string().required("Field is required "),
      }),
    fiveHundred: Yup.string()
      .ensure()
      .when("payMode", {
        is: CASH,
        then: Yup.string().required("Field is required "),
      }),
    twoHundred: Yup.string()
      .ensure()
      .when("payMode", {
        is: CASH,
        then: Yup.string().required("Field is required "),
      }),
    hundred: Yup.string()
      .ensure()
      .when("payMode", {
        is: CASH,
        then: Yup.string().required("Field is required "),
      }),
    chequeNumber: Yup.string()
      .ensure()
      .when("payMode", {
        is: CHEQUE,
        then: Yup.string().required("Field is required "),
      }),
    chequeIssueDate: Yup.string()
      .ensure()
      .when("payMode", {
        is: CHEQUE,
        then: Yup.string().required("Field is required "),
      }),
    chequeExpiryDate: Yup.string()
      .ensure()
      .when("payMode", {
        is: CHEQUE,
        then: Yup.string().required("Field is required "),
      }),
    nameOfBank: Yup.string()
      .ensure()
      .when("payMode", {
        is: CHEQUE,
        then: Yup.string().required("Field is required "),
      }),
    accountHolderName: Yup.string()
      .ensure()
      .when("payMode", {
        is: CHEQUE,
        then: Yup.string().required("Field is required "),
      }),
    accountNumber: Yup.string()
      .ensure()
      .when("payMode", {
        is: CHEQUE,
        then: Yup.string().required("Field is required "),
      }),
    isOtherAmount: Yup.string().required("Field is required "),
    otherAmount: Yup.string()
      .ensure()
      .when("isOtherAmount", {
        is: "OtherAmount",
        then: Yup.string().required("Other amount is required "),
      }),
  });
  if (payFrom === PAYMENT_DUE) {
    validationSchema = Yup.object().shape({
      courseFee: Yup.string().required("Course Fee is required "),
      payMode: Yup.string().required("PayMode is required "),
      isOtherAmount: Yup.string().required("Field is required "),
      twoThousand: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      fiveHundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      twoHundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      hundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      chequeNumber: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      chequeIssueDate: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      chequeExpiryDate: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      nameOfBank: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      accountHolderName: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      accountNumber: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      isOtherAmount: Yup.string().required("Field is required "),
      otherAmount: Yup.string()
        .ensure()
        .when("isOtherAmount", {
          is: "OtherAmount",
          then: Yup.string().required("Field is required "),
        }),
    });
  }
  if (payFrom === ADMISSION_FORWARD) {
    validationSchema = Yup.object().shape({
      courseFee: Yup.string().required("Course Fee is required "),
      payMode: Yup.string().required("PayMode is required "),
      isOtherAmount: Yup.string().required("Field is required "),
      twoThousand: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      fiveHundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      twoHundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      hundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      chequeNumber: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      chequeIssueDate: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      chequeExpiryDate: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      nameOfBank: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      accountHolderName: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      accountNumber: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      isOtherAmount: Yup.string().required("Field is required "),
      otherAmount: Yup.string()
        .ensure()
        .when("isOtherAmount", {
          is: "OtherAmount",
          then: Yup.string().required("Field is required "),
        }),
    });
  }
  if (payFrom === PAYMENT_FOR_DRESS) {
    validationSchema = Yup.object().shape({
      amount: Yup.number().required("Amount is required "),
      comment: Yup.string().required("comment is required "),
      payMode: Yup.string().required("PayMode is required "),
      twoThousand: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      fiveHundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      twoHundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      hundred: Yup.string()
        .ensure()
        .when("payMode", {
          is: CASH,
          then: Yup.string().required("Field is required "),
        }),
      chequeNumber: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      chequeIssueDate: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      chequeExpiryDate: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      nameOfBank: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      accountHolderName: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        }),
      accountNumber: Yup.string()
        .ensure()
        .when("payMode", {
          is: CHEQUE,
          then: Yup.string().required("Field is required "),
        })
    });
  }
  const {
    register,
    handleSubmit,
    reset,
    watch,
    unregister,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      payMode: ONLINE,
      courseFee: payData.courseFee,
      // discountType: FULL_PAYMENT,
      isOtherAmount: "ToBePaid",
      discount: 0,
      // payMode: CASH,
      // twoThousand:17,
      // fiveHundred:2,
      // hundred:0,
      // twoHundred:0
    },
    resolver: yupResolver(validationSchema),
  });
  const payMode = watch("payMode");
  const discountType = watch("discountType");
  const discount = watch("discount");
  const isOtherAmount = watch("isOtherAmount");
  const otherAmountWatch = watch("otherAmount");
  

  const twoThousandWatch = watch("twoThousand");
  const fiveHundredWatch = watch("fiveHundred");
  const twoHundredWatch = watch("twoHundred");
  const hundredWatch = watch("hundred");
  

  useEffect(() => {
    //fetch Course fee
    setCourseFee(payData.courseFee);
    setTotalFee(payData.totalFee);
    // setValue({courseFee: 5000})
  }, [payData]);

  useEffect(() => {
    console.log(twoThousandWatch,fiveHundredWatch,twoHundredWatch,hundredWatch)
    setCashValue(( ( (twoThousandWatch * 2000) || 0 ) +  ( (fiveHundredWatch * 500) || 0 ) +  ( (twoHundredWatch * 200) || 0 ) +  ( (hundredWatch * 100) || 0 ) ))
  }, [twoThousandWatch,fiveHundredWatch,twoHundredWatch,hundredWatch,otherAmountWatch])
  
  useEffect(() => {
    if(discount){
      updateTotalFee(discount || 0);
    }else{
      // setValue("discount",FIXEDDISC)
    }
  }, [discount]);

  useEffect(() => {
    if (payFrom === ADMISSION || payFrom === ADMISSION_FORWARD || payData.isDiscountsEnabled) {
      setRefType(discountType);
      if (discountType !== REFERENCE) {
        if (discountType === STAFF) {
          const discountAmt = courseFee * (STAFFDISC / 100);
          // setValue("discount",discountAmt)
          updateTotalFee(discountAmt);
        } else if (discountType === FULL_PAYMENT || discountType === TWIN) {
          // setValue("discount",FIXEDDISC);
          console.log("Discount Full payment",FIXEDDISC)
          if(discountType === FULL_PAYMENT){
            setValue("isOtherAmount","ToBePaid")
          }
          updateTotalFee(FIXEDDISC);
        }
      } else {
        updateTotalFee(0);
      }
    }
  }, [discountType]);

  useEffect(() => {
    if (isOtherAmount === "ToBePaid") {
      setValue("otherAmount", null);
    }
  }, [isOtherAmount]);

  const updateTotalFee = (discount) => {
    console.log(courseFee)
    setTotalFee(payData.otherFee + (courseFee - parseInt(discount)));
  };

  const paymentRequest = async (data) => {
    const {
      paidAmount,
      accountHolderName,
      accountNumber,
      chequeExpiryDate,
      chequeIssueDate,
      chequeNumber,
      courseFee,
      discount,
      discountType,
      fiveHundred,
      hundred,
      nameOfBank,
      payMode,
      refName,
      twoHundred,
      twoThousand,
      isOtherAmount,
      otherAmount,
    } = data;
    
    
    let reqParams = {
      totalAmount: courseFee,
      paidAmount: totalFee,
      payMode,
      discountType,
      academicStartDate: payData.academicStartDate,
      academicEndDate: payData.academicEndDate,
      StudentId: studentProfileDetails.id,
      payFrom,
      OtherFeeId: payData.OtherFeeId,
      BranchClassGroupId: ((payData && payData.BranchClassGroup) ? payData.BranchClassGroup.id : null),
      sendPaymentURLMother: false,
      sendPaymentURLFather: false,
    };

    if (payMode === SEND_PAYMENT_LINK_MOTHER) {
      reqParams.payMode = ONLINE;
      reqParams.sendPaymentURLMother = true;
    }
    if (payMode === SEND_PAYMENT_LINK_FATHER) {
      reqParams.payMode = ONLINE;
      reqParams.sendPaymentURLFather = true;
    }
    if (discountType === REFERENCE) {
      reqParams.refName = refName;
      reqParams.discount = discount;
    } else {
      reqParams.discount =
        ( (parseInt(courseFee) + payData.otherFee) - parseInt(totalFee) );
    }

    if (payFrom === PAYMENT_DUE) {
      reqParams.totalAmount = payData.dueAmount;
      reqParams.paidAmount = payData.dueAmount;
      reqParams.StudentId = payData.StudentId;
      reqParams.StudentFeeId = payData.StudentFeeId;
      reqParams.discount = payData.isDiscountsEnabled ? reqParams.discount : 0;
      reqParams.payFrom = payFrom;
    }
    if(payFrom === PAYMENT_DUE && payData.isDiscountsEnabled){
      reqParams.discountType = discountType;
      reqParams.paidAmount = totalFee;
      reqParams.refName = refName;
    }
    if (payFrom === ADMISSION_FORWARD) {
      // reqParams.discountType = null;
      reqParams.StudentFeeId = payData.StudentFeeId;
    }

    if (isOtherAmount === "OtherAmount") {
      reqParams.paidAmount = otherAmount;
    }
    if (payFrom === PAYMENT_FOR_DRESS) {
      reqParams.amount = data.amount;
      reqParams.paidAmount = data.amount;
      reqParams.comment = data.comment;
      reqParams.StudentId = payData.StudentId;
      reqParams.payFrom = payFrom;
    }

    if(payMode === CASH){
     let payableAmount =  isOtherAmount === "ToBePaid" ? totalFee : otherAmountWatch;
     if(payableAmount > cashValue) {
      ToastMessage(ERROR, "Denominations count not matched");
      return true;
     }
    }
   

    /*
    if(data.payMode === CASH){
      const currencyNotesAmount = (2000 * twoThousand) + (500 * fiveHundred) + (200 * twoHundred) + (100 * hundred) ;
      if(currencyNotesAmount === parseInt(reqParams.paidAmount)){
          console.log("amount Equal")
      }else{
        console.log("Amount Not Equal")
        ToastMessage(ERROR, "Denominations count not matched");
        return true;

      }
    }
    */

    switch (data.payMode) {
      case ONLINE:
        break;
      case CASH:
        reqParams.noOfNotesCollected = {
          twoThousand,
          fiveHundred,
          twoHundred,
          hundred,
        };
        break;
      case CHEQUE:
        reqParams.chequeNumber = chequeNumber;
        reqParams.chequeExpiryDate = chequeExpiryDate;
        reqParams.chequeIssueDate = chequeIssueDate;
        reqParams.nameOfBank = nameOfBank;
        reqParams.accountHolderName = accountHolderName;
        reqParams.accountNumber = accountNumber;
        break;

      default:
        break;
    }
    
    if(payMode === ONLINE || payMode === CHEQUE){
      let payableAmount =  isOtherAmount === "ToBePaid" ? totalFee : otherAmountWatch;
      console.log(reqParams,reqParams.paidAmount,payableAmount,otherAmountWatch)
      if(reqParams.totalAmount < parseInt(reqParams.paidAmount)) {
       ToastMessage(ERROR, "Paid Amount should not be more than Total Amount");
       return true;
      }
    }

    console.log(reqParams)
    // await dispatch(payNow(reqParams));
    setPaymentConfirmShow(true);
    setPaymentReqParams(reqParams)
    // reset();
    // return true;
  };

  const submitPayment =async()=>{
    const chequeExpiryDateInDateObjectFormat = new Date(paymentReqParams.chequeExpiryDate);
    const chequeIssueDateInDateObjectFormat = new Date(paymentReqParams.chequeIssueDate);

    if (paymentReqParams.payMode === "Cheque" && (chequeExpiryDateInDateObjectFormat < chequeIssueDateInDateObjectFormat)) {
      ToastMessage(ERROR, 'Cheque Expiry Date should be greater than Cheque Issue Date')
      setPaymentConfirmShow(false);
    } else {
      if (payFrom === PAYMENT_FOR_DRESS || payFrom === PAYMENT_DUE) {
        props.setPayForDressShow(false);
      }

      setPaymentConfirmShow(false);
      await dispatch(payNow(paymentReqParams));
      setPaymentReqParams({})
    }
  }
  const onCancel = ()=>{
    setPaymentConfirmShow(false);
  }
  const handleChange = async (event) => {
    const value = event.target.value;
    const name = event.target.name;
    // setIsOtherAmount(value);
  };

  return (
    <>
      <div className="container-fluid">
      <PageLoader loader={loader}>
      { paymentConfirmShow ? (
               <SweetAlert
               warning="warning"
               showCancel
               confirmBtnText="Continue"
               confirmBtnBsStyle="info"
               title="Are you sure?"
               onConfirm={submitPayment}
               onCancel={onCancel}
               focusCancelBtn
             >
              {/* Payable Amount {isOtherAmount === "ToBePaid" ? totalFee : otherAmountWatch} */}
             </SweetAlert>
   
          ): null } 
        <Form noValidate onSubmit={handleSubmit(paymentRequest)}>
          {payFrom === PAYMENT_FOR_DRESS ? (
            <Form.Row>
              <Form.Group
                className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
                controlId="formFirstName"
              >
                <Form.Label className="label">Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  {...register("amount")}
                  className={`form-control ${
                    errors.amount ? "is-invalid" : ""
                  }`}
                />
                <span classamount="invalid-feedback">
                  {errors.amount?.message}
                </span>
              </Form.Group>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-6 offset-xl-2 required"
                controlId="formLastName"
              >
                <Form.Label className="label">Comment</Form.Label>
                <Form.Control
                  as="textarea"
                  name="comment"
                  rows={3}
                  className={`form-control ${
                    errors.comment ? "is-invalid" : ""
                  }`}
                  {...register("comment")}
                ></Form.Control>

                <span className="invalid-feedback">
                  {errors.comment?.message}
                </span>
              </Form.Group>
            </Form.Row>
          ) : null}

          { (payFrom === ADMISSION || payFrom === ADMISSION_FORWARD || payData.isDiscountsEnabled )? (
            <>
                <>
                  <Form.Row>
                  <Form.Group
                    className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
                    controlId="courseFee"
                  >
                    <Form.Label className="label">
                      Total course fee (in Rs)
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="courseFee"
                      disabled
                      {...register("courseFee")}
                      className={`form-control ${
                        errors.courseFee ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors.courseFee?.message}
                    </span>
                  </Form.Group>
                </Form.Row>
                </>
              {((payData.OtherFees && payData.OtherFees.length > 0) || payData.isDiscountsEnabled) ? (
                <Form.Row>
                  <Form.Group
                    className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
                    controlId="courseFee"
                  >
                    <Form.Label className="label">Other fee (in Rs)</Form.Label>
                    <Form.Control
                      type="number"
                      name="otherFee"
                      disabled
                      {...register("otherFee")}
                      className={`form-control ${
                        errors.otherFee ? "is-invalid" : ""
                      }`}
                      value={payData.otherFee}
                    />
                    <span className="invalid-feedback">
                      {errors.otherFee?.message}
                    </span>
                  </Form.Group>
                </Form.Row>
              ) : null}
              {(payFrom === ADMISSION || payFrom === ADMISSION_FORWARD || payData.isDiscountsEnabled ) ? (
                <>
                  <Form.Row>
                    <Form.Group
                      className={`col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6 required `}
                    >
                      <Form.Label className="label">
                        Discount Type &nbsp;&nbsp;
                      </Form.Label>
                      {/* <div key={`default-radio`} className="mb-3"> */}
                      <div>
                        {DISCOUNTTYPE.map((key) => {
                          return (
                            // <div>
                            <Form.Check
                              type="radio"
                              id={key.value}
                              label={key.label}
                              value={key.value}
                              // onChange={handleChange}
                              // checked={refType === key.value}
                              inline
                              {...register("discountType")}
                              className={`${
                                errors.discountType ? "is-invalid" : ""
                              }`}
                            />
                            // </div>
                          );
                        })}
                        <span className="invalid-feedback">
                          {errors.discountType?.message}
                        </span>
                      </div>
                      {/* </div> */}
                    </Form.Group>
                  </Form.Row>

                  {refType === REFERENCE ? (
                    <div>
                      <Form.Row>
                        <Form.Group
                          className={`col-xs-12 col-sm-12 col-md-2 col-lg-4 col-xl-4 required `}
                          controlId="courseFee"
                        >
                          <Form.Label className="label">Referred By</Form.Label>
                          {/* <Form.Row> */}
                          <Form.Control
                            as="select"
                            name="refName"
                            className={`form-control ${
                              errors.refName ? "is-invalid" : ""
                            }`}
                            {...register("refName")}
                          >
                            <option value="">Please Select</option>
                            {REFREE.map((ele) => (
                              <option value={ele}>{ele}</option>
                            ))}
                          </Form.Control>
                          <span className="invalid-feedback">
                            {errors.refName?.message}
                          </span>
                        </Form.Group>
                        <Form.Group
                          className={`col-xs-12 col-sm-12 col-md-2 col-lg-4 col-xl-4 required `}
                          controlId="courseFee"
                        >
                          <Form.Label className="label">
                            Discount Amount
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="discount"
                            {...register("discount", { required: true })}
                            className={`form-control ${
                              errors.discount ? "is-invalid" : ""
                            }`}
                          />
                          <span className="invalid-feedback">
                            {errors.discount?.message}
                          </span>
                        </Form.Group>
                        .
                      </Form.Row>
                    </div>
                  ) : null}
                </>
              ) : null}
            </>
          ) : null}

          <Form.Row>
            {payFrom === PAYMENT_FOR_DRESS ? null : (
              <Form.Group
                className={`col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 required `}
                controlId="courseFee"
              >
                <Form.Label className="label">
                  <Form.Check
                    type="radio"
                    label="total Fees to be paid (in Rs)"
                    value={"ToBePaid"}
                    // checked={isOtherAmount === "ToBePaid"}
                    inline
                    // onChange={handleChange}
                    {...register("isOtherAmount")}
                  />
                </Form.Label>
                <Form.Control
                  type="number"
                  name="paidAmount"
                  disabled
                  value={totalFee}
                  // {...register("paidAmount")}
                  // className={`form-control ${errors.paidAmount ? "is-invalid" : ""}`}
                />
                <span className="invalid-feedback">
                  {errors.paidAmount?.message}
                </span>
              </Form.Group>
            )}
            {payFrom === ADMISSION || payFrom === ADMISSION_FORWARD || payFrom === PAYMENT_DUE ? (
              <Form.Group
                className={`col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4`}
                controlId="courseFee"
              >
                <Form.Label className="label">
                  <Form.Check
                    type="radio"
                    label="Other Amount"
                    value={"OtherAmount"}
                    // checked={isOtherAmount === "OtherAmount"}
                    inline
                    disabled={discountType === FULL_PAYMENT}
                    // onChange={handleChange}
                    {...register("isOtherAmount")}
                    // className={`${errors.isOtherAmount ? "is-invalid" : ""}`}
                  />
                </Form.Label>
                <Form.Control
                  type="number"
                  name="otherAmount"
                  // value={totalFee}
                  {...register("otherAmount")}
                  className={`form-control ${
                    errors.otherAmount ? "is-invalid" : ""
                  }`}
                />
                <span className="invalid-feedback">
                  {errors.otherAmount?.message}
                </span>
              </Form.Group>
            ) : null}
          </Form.Row>

          <Form.Row>
            <Form.Group
              className={`col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6 required `}
              controlId="courseFee"
            >
              <Form.Label className="label">Mode of Payment </Form.Label>
              <div>
                {PAYMODE_TYPE.map((key) => {
                  return (
                    // <div>
                    <Form.Check
                      type="radio"
                      id={key.value}
                      label={key.label}
                      value={key.value}
                      // onChange={() => setPayMode(key.value)}
                      // checked={payMode === key.value}
                      disabled = {payData.taxBenfits && key.label === CASH}
                      {...register("payMode", { required: true })}
                    />
                    // </div>
                  );
                })}
              </div>
            </Form.Group>
          </Form.Row>
          {payMode === CASH && (
            <>
            <div>
              <Form.Row>
                <Form.Label className={`label`}>
                  Number of Notes Collected{" "}  
                </Form.Label>
              </Form.Row>
              <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8 col-xl-8">
                  <Form.Row>
                <Form.Group
                  className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
                  controlId="courseFee"
                >
                  <Form.Label className="label">2000</Form.Label>
                  <Form.Control
                    type="number"
                    name="twoThousand"
                    {...register("twoThousand")}
                    className={`form-control ${
                      errors.twoThousand ? "is-invalid" : ""
                    }`}
                  />
                  <span className="invalid-feedback">
                    {errors.twoThousand?.message}
                  </span>
                </Form.Group>
                <Form.Group
                  className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
                  controlId="fiveHundred"
                >
                  <Form.Label className="label">500</Form.Label>
                  <Form.Control
                    type="number"
                    name="fiveHundred"
                    {...register("fiveHundred")}
                    className={`form-control ${
                      errors.fiveHundred ? "is-invalid" : ""
                    }`}
                  />
                  <span className="invalid-feedback">
                    {errors.fiveHundred?.message}
                  </span>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group
                  className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
                  controlId="twoHundred"
                >
                  <Form.Label className="label">200</Form.Label>
                  <Form.Control
                    type="number"
                    name="twoHundred"
                    {...register("twoHundred")}
                    className={`form-control ${
                      errors.twoHundred ? "is-invalid" : ""
                    }`}
                  />
                  <span className="invalid-feedback">
                    {errors.twoHundred?.message}
                  </span>
                </Form.Group>
                <Form.Group
                  className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
                  controlId="courseFee"
                >
                  <Form.Label className="label">100</Form.Label>
                  <Form.Control
                    type="number"
                    name="hundred"
                    {...register("hundred")}
                    className={`form-control ${
                      errors.hundred ? "is-invalid" : ""
                    }`}
                  />
                  <span className="invalid-feedback">
                    {errors.hundred?.message}
                  </span>
                </Form.Group>
              </Form.Row>
                    </div>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <Table responsive className="m-0 data-table-shadow">
                  <thead style={{ 
                    backgroundColor: "#1c5984" ,color:"#ffff"}}>
                    <tr>
                  <th
                    scope="col"
                    style={{ padding: "10px 0px 10px 0px" }}
                    className="text-center"
                  >
                    Notes
                  </th>
                  <th
                    scope="col"
                    style={{ padding: "10px 0px 10px 0px" }}
                    className="text-center"
                  >
                    Total
                  </th>
                  <th
                    scope="col"
                    style={{ padding: "10px 0px 10px 0px" }}
                    className="text-center"
                  >
                    Total Amount
                  </th>
                  <th
                    scope="col"
                    style={{ padding: "10px 0px 10px 0px" }}
                    className="text-center"
                  >
                    Return Amount
                  </th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr>
                      <td
                        className={`text-center`}
                      >
                        {twoThousandWatch} &nbsp; * 2000
                      </td>
                      <td
                        className={`text-center`}
                      >
                        { (twoThousandWatch * 2000) || null  }
                      </td>
                      <th
                        className={`text-center`}
                        rowSpan="4"
                      >
                        { cashValue  }
                      </th>
                      <th
                        className={`text-center`}
                        rowSpan="4"
                      >
                        { ( isOtherAmount === 'ToBePaid' ? (totalFee < cashValue ? (cashValue-totalFee) : 0 ) : (otherAmountWatch < cashValue ? (cashValue-otherAmountWatch) : 0 ) )  }
                      </th>
                      </tr>
                      <tr>
                      <td
                        className={`text-center`}
                      >
                        {fiveHundredWatch} &nbsp; * 500
                      </td>
                      <td
                        className={`text-center`}
                      >
                        { (fiveHundredWatch * 500) || null  }
                      </td>
                      </tr>
                      <tr>
                      <td
                        className={`text-center`}
                      >
                        {twoHundredWatch} &nbsp; * 200
                      </td>
                      <td
                        className={`text-center`}
                      >
                        { (twoHundredWatch * 200) || null  }
                      </td>
                      </tr>
                      <tr>
                      <td
                        className={`text-center`}
                      >
                        {hundredWatch} &nbsp; * 100
                      </td>
                      <td
                        className={`text-center`}
                      >
                        { (hundredWatch * 100) || null  }
                      </td>
                      </tr>
                    </tbody>
                  </Table>
                    </div>
              </div>
            </div>
            
            </>
          )}
          {payMode === CHEQUE && (
            <div>
              <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
                  controlId="checkIssueDate"
                >
                  <Form.Label className="label">Cheque Issue Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="chequeIssueDate"
                    className={`form-control ${
                      errors.chequeIssueDate ? "is-invalid" : ""
                    }`}
                    {...register("chequeIssueDate")}
                  />
                  <span className="invalid-feedback">
                    {errors.chequeIssueDate?.message}
                  </span>
                </Form.Group>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
                  controlId="ced"
                >
                  <Form.Label className="label">Cheque expiry Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="chequeExpiryDate"
                    className={`form-control ${
                      errors.chequeExpiryDate ? "is-invalid" : ""
                    }`}
                    {...register("chequeExpiryDate")}
                  />
                  <span className="invalid-feedback">
                    {errors.chequeExpiryDate?.message}
                  </span>
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
                  controlId="bankName"
                >
                  <Form.Label className="label">Name of Bank</Form.Label>
                  <Form.Control
                    type="text"
                    name="nameOfBank"
                    className={`form-control ${
                      errors.nameOfBank ? "is-invalid" : ""
                    }`}
                    {...register("nameOfBank")}
                  />
                  <span className="invalid-feedback">
                    {errors.nameOfBank?.message}
                  </span>
                </Form.Group>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
                  controlId="chequeNo"
                >
                  <Form.Label className="label">Cheque Number</Form.Label>
                  <Form.Control
                    type="number"
                    name="chequeNumber"
                    className={`form-control ${
                      errors.chequeNumber ? "is-invalid" : ""
                    }`}
                    {...register("chequeNumber")}
                  />
                  <span className="invalid-feedback">
                    {errors.chequeNumber?.message}
                  </span>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
                  controlId="accName"
                >
                  <Form.Label className="label">Account holder Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="accountHolderName"
                    className={`form-control ${
                      errors.accountHolderName ? "is-invalid" : ""
                    }`}
                    {...register("accountHolderName")}
                  />
                  <span className="invalid-feedback">
                    {errors.accountHolderName?.message}
                  </span>
                </Form.Group>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
                  controlId="accNo"
                >
                  <Form.Label className="label">Account Number</Form.Label>
                  <Form.Control
                    type="number"
                    name="accountNumber"
                    className={`form-control ${
                      errors.accountNumber ? "is-invalid" : ""
                    }`}
                    {...register("accountNumber")}
                  />
                  <span className="invalid-feedback">
                    {errors.accountNumber?.message}
                  </span>
                </Form.Group>
              </Form.Row>
            </div>
          )}
          {payMode && (
            <div>
              <Button variant="primary app-default-button" type="submit">
                Pay Now
              </Button>
            </div>
          )}
        </Form>
        </PageLoader>
      </div>
    </>
  );
};

export default PaymentDetails;
